export const hasFileDragData = (event) => {
  const transfer = event?.dataTransfer;
  return Boolean(transfer && (
    transfer.files?.length
    || Array.from(transfer.items || []).some((item) => item?.kind === 'file')
    || Array.from(transfer.types || []).includes('Files')
  ));
};

// The page importer must yield to local drop areas and modal tasks. Checking
// here, during capture, prevents it from covering them before React handles
// their drag event. Disabled editors still own their area and reject the drop.
export const hasLocalFileDropTarget = (event) => {
  const target = event?.target?.nodeType === 1 ? event.target : event?.target?.parentElement;
  if (target?.closest?.('[data-file-drop-target], input, textarea, [contenteditable], [role="dialog"], [role="alertdialog"]')) {
    return true;
  }
  const ownerDocument = event?.target?.nodeType === 9 ? event.target : target?.ownerDocument;
  // keepMounted dialogs can leave aria-modal on their paper while the modal
  // root is hidden. Only an active modal should suspend page-wide importing.
  const modals = ownerDocument?.querySelectorAll(
    '[aria-modal="true"], .MuiModal-root [role="dialog"], .MuiModal-root [role="alertdialog"]'
  ) || [];
  return Array.from(modals).some((modal) => !modal.closest(
    '[aria-hidden="true"], [hidden], .MuiModal-hidden'
  ));
};
